import * as CryptoJS from "crypto-js";
export interface IStorageService {
  setItem<T>(key: string, value: T): void;
  getItem<T>(key: string): T | null;
  removeItem(key: string): void;
  clear(): void;
}

export class EncryptionStorageService implements IStorageService {
  private secretKey: string;

  constructor(secretKey: string) {
    this.secretKey = secretKey;
  }

  setItem<T>(key: string, value: T): void {
    try {
      const serializedValue = JSON.stringify(value);
      const encryptedValue = CryptoJS.AES.encrypt(
        serializedValue,
        this.secretKey
      ).toString();
      localStorage.setItem(key, encryptedValue);
    } catch (error) {
      console.error(
        `Error encrypting and saving ${key} to localStorage:`,
        error
      );
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;

      const bytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
      const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedValue) as T;
    } catch (error) {
      console.error(
        `Error decrypting and getting ${key} from localStorage:`,
        error
      );
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing ${key} from localStorage:`, error);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }
  }
}
export const localStorageService = new EncryptionStorageService("@Abc#$%");
